import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-provider-avatar-photo',
    templateUrl: './provider-avatar-photo.component.html',
    styleUrls: ['./provider-avatar-photo.component.scss'],
    standalone: false
})
export class ProviderAvatarPhotoComponent implements OnInit {
    constructor() {}

    @Input() public width: number;
    @Input() public height: number;
    @Input() public photoUrl: string;
    @Input() public firstName: string;
    @Input() public lastName: string;
    @Input() floatLeft: boolean = false;

    ngOnInit() {}
}
